import "./Career.css";

const experience = [
  { period: "Summer 2026", role: "WISE Intern - Device Embedded Systems", company: "Medtronic PLC · Mounds View, MN", detail: "" },
  { period: "2023 — 2026", role: "Programming Captain", company: "FRC 2052 · KnightKrawler", detail: "Led the programming team in developing and maintaining the robot's codebase over 3 seasons." },
  { period: "EDUCATION", role: "University of Minnesota", company: "B.S. Computer Engineering, Expected May 2030", detail: "University Honors Student" },
];

function Career() {
  return <div className="timeline">{experience.map((item) =>
    <article className="timeline-item" key={item.role}>
      <p className="timeline-period">{item.period}</p>
      <div>
        <h3>{item.role}</h3><p className="timeline-company">{item.company}</p>
        <p>{item.detail}</p>
      </div>
    </article>)}
  </div>
}

export default Career;
